import { useEffect, useRef } from 'react';
import { isDeepEqual } from 'utils/isDeepEqual';

export const useDeepCompare = <T,>(value: T): T => {
    const previousValueRef = useRef<T>(value);

    useEffect(() => {
        if (!isDeepEqual(previousValueRef.current, value)) {
            previousValueRef.current = value;
        }
    }, [value]);

    return previousValueRef.current;
};
